function clearKeys(obj, ...keys) {
    let params = { ...obj }
    keys.forEach(key => {
        if (params[key]) params[key] = ''
    })
    return params
}

export { clearKeys }
